// extracted by mini-css-extract-plugin
module.exports = {"phone-input-form":"_227EThDv","phoneInputForm":"_227EThDv"};